export default "__VITE_ASSET__xQfCmOvg__"